import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ActionPayload {
  visible?: boolean;
  deviceData?: any;
}

const initialState: ActionPayload = {
  deviceData: "",
  visible: false,
};

const ethernetSlice = createSlice({
  name: "toaster",
  initialState,
  reducers: {
    setEthernetValue: (state, action: PayloadAction<any>) => {
      state.visible = action.payload.visible;
      state.deviceData = action.payload.deviceData;
    },
  },
});

export const { setEthernetValue } = ethernetSlice.actions;
export default ethernetSlice.reducer;
